"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.McpApprovalPolicyUpdateRequestModel = void 0;
var McpApprovalPolicyUpdateRequestModel_1 = require("./McpApprovalPolicyUpdateRequestModel");
Object.defineProperty(exports, "McpApprovalPolicyUpdateRequestModel", { enumerable: true, get: function () { return McpApprovalPolicyUpdateRequestModel_1.McpApprovalPolicyUpdateRequestModel; } });
